import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HighlightAnalytic } from '../models/analytic.model';
import { UsageTrackingServiceInterface } from '../models/usage-tracking-service.interface';
import { APPLICATION, GENERAL_ACTION_TYPES } from '../usage-tracking.config';
import { DashboardNavigationInfoService } from './dashboarad-navigation-info.service';
import { TrackingService } from './tracking.service';

@Injectable({ providedIn: 'root' })
export class HighlightTrackingService implements UsageTrackingServiceInterface {
  private readonly dashboardNavigationInfoService = inject(
    DashboardNavigationInfoService
  );
  private readonly trackingService = inject(TrackingService);
  private readonly router = inject(Router);

  private haveDrawn: boolean = false;

  public addUsageTracking(): void {
    const action = GENERAL_ACTION_TYPES.highlight;
    const application = APPLICATION;

    const highlightAnalytic: HighlightAnalytic = {
      url: this.router.url,
      application,
      action,
      ...this.dashboardNavigationInfoService.getNavigationInfo(),
    };

    if (!this.haveDrawn) {
      return;
    }
    this.haveDrawn = false;
    this.trackingService.addUsageTracking(highlightAnalytic);
  }

  public setHaveDrawn(haveDrawn: boolean) {
    this.haveDrawn = haveDrawn;
  }
}
